import { docodeHexResponse } from '../../_common/common.utils';
import PortFlioAtRiskTypes from './portfolio-at-risk-report.type';

const INITIAL_STATE = {
	totalCount: 0,
	TotalLoanAmount: 0,
	TotalLoanAmountReceived: 0,
	TotalLoanOLBAmount: 0,
	TotalLoanOLBInterestAmount: 0,
	TotalLoanOverAmount: 0,
	TotalLoanOverInterestAmount: 0,

	SevenDays: 0,
	ForteenDays: 0,
	ForteenDaysTotalAmount: 0,
	FortyTwoDays: 0,
	FortyTwoDaysMoreThanTotalAmount: 0,
	FortyTwoDaysTotalAmount: 0,
	MoreThanFortyTwoDays: 0,
	MoreThanSixtyThreeDays: 0,

	SevenDaysTotalAmount: 0,
	SixtyThreeDaysMoreThanTotalAmount: 0,
	ThirtyFiveDays: 0,
	ThirtyFiveDaysTotalAmount: 0,
	TotalBranchAmount: 0,
	TotalLoanAmountArrear: 0,
	TotalLoanPARValue: 0,
	TwentyEightDays: 0,
	TwentyEightDaysTotalAmount: 0,
	TwentyOneDays: 0,
	TwentyOneDaysTotalAmount: 0,

	PortflioAtRiskResponse: null,
	PortflioAtRiskArr: [],

	UserDetailsResponse: null,
	UserDetailskArr: [],

	LoanInfoBasedOnMemberResponse: null,
	LoanInfoBasedOnMemberArr: [],
};

const portfolioAtRiskReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************GET PORTFOLIO AT RISK START ************* */
		case PortFlioAtRiskTypes.PORTFLIO_AT_RISK_SUCCESS:
			return {
				...state,
				PortflioAtRiskResponse: action.payload,
				PortflioAtRiskArr: docodeHexResponse(action.payload, 'GetPortfolioAtRiskReportKey'),
			};

		case PortFlioAtRiskTypes.PORTFLIO_AT_RISK_FAILURE:
			return { ...state, PortflioAtRiskResponse: action.payload };

		case PortFlioAtRiskTypes.PORTFLIO_AT_RISK_RESPONSE_CHANGED:
			return { ...state, PortflioAtRiskResponse: null };
		/** ***************GET PORTFOLIO AT RISK END ************* */

		/** *********************LOAN_INFO_BASEDON_MEMBER START ******** */
		case PortFlioAtRiskTypes.GET_LOAN_INFO_BASEDON_MEMBER_SUCCESS:
			return {
				...state,
				LoanInfoBasedOnMemberResponse: action.payload,
				LoanInfoBasedOnMemberArr: docodeHexResponse(
					action.payload,
					'LoanInfoBasedOnMemberClosedKey',
				),
			};

		case PortFlioAtRiskTypes.GET_LOAN_INFO_BASEDON_MEMBER_FAILURE:
			return { ...state, LoanInfoBasedOnMemberResponse: action.payload };

		case PortFlioAtRiskTypes.GET_LOAN_INFO_BASEDON_MEMBER_RESPONSE_CHANGED:
			return { ...state, LoanInfoBasedOnMemberResponse: null };
		/** *********************LOAN_INFO_BASEDON_MEMBER END ******** */

		default:
			return state;
	}
};

export default portfolioAtRiskReducer;
